import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

// text,email,tel,textarea,password,
@Component({
  selector: 'app-file',
  template: `
    <div [formGroup]="form">
      <div
        *ngIf="!fileBase64"
        class="drop-container dropzone"
        dropZone
        (hovered)="toggleHover($event)"
        (dropped)="onUpload($event)"
        [class.hovering]="isHovering"
      >
        <p class="m-0">
          Drag a file here or
          <label class="upload-button">
            <input
              [formControlName]="field.formControlName"
              type="file"
              multiple=""
              (change)="onUpload($event)"
            />
            browse
          </label>
          to upload.
        </p>
      </div>
      <div *ngIf="fileBase64" style="display: flex;
    justify-content: space-between;
    align-items: center;">
        <!-- <div class="card"> -->
          <a *ngIf="fileType === 1" [href]="fileBase64" download="my-img.png">
            <img  class="card-img-top" [src]="fileBase64"/>
          </a>
          <a *ngIf="fileType === 2" [href]="fileBase64" download="my-fancy.pdf" >Download PDF</a>
          <button type="button" class="btn btn-primary" (click)="onClear()">Clear</button>
        <!-- </div> -->
      </div>
    </div>
  `,
  styles: [
    `
      .card-img-top {
        width: 4rem;
        cursor: pointer;
      }
      .drop-container {
        background: #fff;
        border-radius: 6px;
        height: 150px;
        width: 100%;
        box-shadow: 1px 2px 20px hsla(0, 0%, 4%, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        border: 2px dashed #c0c4c7;
      }
      p {
        font-size: 16px;
        font-weight: 400;
        color: #c0c4c7;
      }
      .upload-button {
        display: inline-block;
        border: none;
        outline: none;
        cursor: pointer;
        color: #5754a3;
      }
      .upload-button input {
        display: none;
      }
      .dropzone {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        border-radius: 5px;
        background: white;
        margin: 10px 0;
      }
      .dropzone.hovering {
        border: 2px solid #f16624;
        color: #dadada !important;
      }
      progress::-webkit-progress-value {
        transition: width 0.1s ease;
      }
    `,
  ],
})
export class FileComponent {
  @Input() field: any = {};
  @Input() form: FormGroup;
  fileBase64: string | ArrayBuffer | SafeUrl;
  pdf: string;
  fileType: number;
  get isValid() {
    return this.form.controls[this.field.name].valid;
  }
  get isDirty() {
    return this.form.controls[this.field.name].dirty;
  }

  isHovering: any;

  constructor(private domSanitizer: DomSanitizer) {}

  toggleHover(event: any) {}

  onUpload(e) {
    const file = e.target.files[0];
    let ext = file.name.split('.').pop();
    if (ext !== 'pdf') {
      this.fileType = 1;
    } else {
      this.fileType = 2;
    }
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      this.fileBase64 = this.domSanitizer.bypassSecurityTrustUrl(fileReader.result as string)
      // to download the pdf progamatically..
      // window.open("data:application/octet-stream;base64," + (fileReader.result as string).split(',')[1]);
    };
  }

  onClear() {
    this.fileBase64 = ""
  }

  ngOnChange() {
    // this.field.value.
  }
}
